import { styled } from '@mui/material/styles';
import { ReactNode } from 'react';
import { NavLink, NavLinkProps } from 'react-router';

export const StyledSectionMenuItem = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  cursor: 'pointer',
  position: 'relative',
  width: '100%',
  height: theme.constants.sidebarElementSize,
  transition: 'all 0.1s ease',
  boxSizing: 'border-box',

  '&:hover': {
    backgroundColor: 'var(--color-general-grey-100)',
  },
}));

const StyledSectionMenuLink = styled((props: NavLinkProps) => (
  <NavLink {...props} />
))<{ to: string }>(({ theme }) => ({
  height: '100%',
  width: '100%',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  svg: {
    fill: 'var(--color-neutral-600)',
  },
  '&::before': {
    content: '""',
    position: 'absolute',
    left: '0',
    top: '0',
    height: '100%',
    width: '0',
    backgroundColor: 'var(--color-blue-500)',
    transition: 'all 0.1s ease',
  },

  '&.active': {
    backgroundColor: 'var(--color-general-grey-100)',
    cursor: 'default',

    '&:before': {
      width: '2px',
    },

    'svg *': {
      fill: 'var(--color-blue-500)',
    },
  },
}));

export type SidebarOptionProps = {
  children: ReactNode;
  path: string;
};

export const SidebarOption = ({ children, path }: SidebarOptionProps) => {
  return (
    <StyledSectionMenuItem>
      <StyledSectionMenuLink role="button" to={path}>
        {children}
      </StyledSectionMenuLink>
    </StyledSectionMenuItem>
  );
};
